module.exports = __webpack_public_path__ + "img/domain-life.7a6198ce.svg";